export enum SubscriptionType {
  Inactive = 0,
  Active = 1,
  Fremium = 2,
}
